/**
 * Created by Mark on 18/04/2017.
 */


import ENVIRONMENT_CONSTANTS from './environment.js'

export default {
    VALIDATE_CLASS_NAME_CALL : ENVIRONMENT_CONSTANTS.BASE_URL + '/classController/verifyClassName',
    GET_VIEWABLE_CLASS_CALL  : ENVIRONMENT_CONSTANTS.BASE_URL + '/classController/getViewableClasses',
    GET_VIEWABLE_CLASS_NAMES : ENVIRONMENT_CONSTANTS.BASE_URL + '/classController/getViewableClassesNameList',
    UPDATE_CLASSES : 'UPDATE_CLASSES',
    UPDATE_NAMES_CLASSES_LIST : 'UPDATE_NAMES_CLASSES_LIST',
    CREATE_CLASS:ENVIRONMENT_CONSTANTS.BASE_URL + '/classController/createClass',
    GET_CLASS: ENVIRONMENT_CONSTANTS.BASE_URL + '/classController/getClass',
    UPDATE_CLASS : 'GET_CLASS',
    GET_CLASS_ACTIVITY : ENVIRONMENT_CONSTANTS.BASE_URL + '/recentActivity/getAllClassActivity',
    GET_PROGRESS_REPORTS : ENVIRONMENT_CONSTANTS.BASE_URL + '/classController/getProgressReport',
    UPDATE_CLASS_ACTIVITY : 'UPDATE_CLASS_ACTIVITY',
    ADD_STUDENTS:ENVIRONMENT_CONSTANTS.BASE_URL + '/classController/addStudents',
    DELETE_CLASS:ENVIRONMENT_CONSTANTS.BASE_URL + '/classController/deleteClass',
    REMOVE_STUDENT:ENVIRONMENT_CONSTANTS.BASE_URL + 'classController/removeUser',
    EDIT_CLASS:ENVIRONMENT_CONSTANTS.BASE_URL + '/classController/editClass'
}



// WEBPACK FOOTER //
// ./src/constants/classes.js